module.exports = __webpack_public_path__ + "static/broadcaster-bg-1ad3f533cdcad8b948dc8b56e5c21759.png";